import React from 'react';
import { useTranslation } from 'react-i18next';
import './index.css';

const CERTIFICATES = [
  {
    key: 'patent1',
    title: '一种带伸缩展平功能的裁刀装置',
    subtitle: '实用新型专利证书',
    src: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/images/honor/patent1.webp',
    alt: '裁刀装置专利证书',
  },
  {
    key: 'patent2',
    title: '一种铺布机滑线电轨',
    subtitle: '实用新型专利证书',
    src: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/images/honor/patent2.webp',
    alt: '铺布机滑线电轨专利证书',
  },
  {
    key: 'patent3',
    title: '一种气缸驱动的铺布装置',
    subtitle: '实用新型专利证书',
    src: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/images/honor/patent3.webp',
    alt: '气缸驱动铺布装置专利证书',
  },
  {
    key: 'certificate',
    title: '质量体系管理证书',
    subtitle: 'ISO 质量管理体系认证',
    src: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/images/honor/certificate.webp',
    alt: '质量体系管理证书',
  },
];

function HonorCard({ cert, isZh }) {
  return (
    <div className="honor-card">
      <div className="honor-card__img-wrap">
        <img
          className="honor-card__img"
          src={cert.src}
          alt={cert.alt}
          loading="lazy"
        />
        <div className="honor-card__badge">
          <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
            <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
          </svg>
        </div>
      </div>
      <div className="honor-card__body">
        <div className="honor-card__subtitle">{cert.subtitle}</div>
        <h3 className="honor-card__title">{cert.title}</h3>
      </div>
    </div>
  );
}

export default function HonorPage() {
  const { i18n } = useTranslation();
  const isZh = !i18n.language.startsWith('en');

  return (
    <div className="honor-grid">
      {CERTIFICATES.map((cert) => (
        <HonorCard key={cert.key} cert={cert} isZh={isZh} />
      ))}
    </div>
  );
}
